/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function n(n){let t=0,e=0;const o=Object.keys(n);for(const c of o){if(null==n[c]){e++;continue}t|=(1&Number(n[c]))<<e,e++}return(31&t)<<26}export{n as getDefinesKey};
